export default __webpack_public_path__ + "static/media/chakhokhbili.034c46e0.png";